import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';

import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  create_order_used_record_by_card,
  delete_card_record,
  get_project_by_id,
  active_card_record,
  get_card_by_id,
  create_card_record,
  get_customer_wallet_fl_rate,
  direct_delete_set_record,
  direct_delete_card_record,
  trans_card_record,
  delete_appointment,
} from '@/api/mjstore-model';
import moment from 'moment';
const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
import modalBox from '@/components/form-modal/modal-tools';
import { message, Modal, notification } from 'ant-design-vue';

export const event_obj = mitt();
import { createVNode, reactive } from 'vue';
import bus from '@/utils/bus';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
const event_bus = bus;

export const btn_list = [
  {
    name: '激活',
    clazz: 'primary',
    is_show: (record: any) => {
      return (record.used_status == 0 || record.used_status == 1) && record.card_type == 11;
    },
    cb: (record: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '激活',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'datepicker',
              name: 'date',
              label: '激活时间',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              showTime: false,
              placeholder: '请选择激活时间',
            },
          ],
          rules: {
            date: [{ required: true, message: '请选择激活时间' }],
          },

          model: {
            org_id: current_org?.id,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            active_card_record({
              org_id: current_org?.id,
              card_record_id: record.id,
              date: payload.date,
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '激活成功',
                });
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '耗卡',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.card_type != 31 && (record.used_status == 2 || record.card_type == 1);
    },
    cb: (record: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        title: '耗卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [7, 10],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
            },
            {
              type: 'input',
              name: 'card__name',
              label: '卡',
              disabled: true,
            },
            {
              type: 'number',
              name: 'card_num',
              label: '消耗卡次',
              disabled: false,
              placeholder: '请输入消耗卡次',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '项目单价',
              disabled: true,
            },
            {
              type: 'input',
              name: 'price',
              label: '项目金额',
              disabled: true,
              slots: { customRender: 'round_price' },
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
              mode: 'default',
              allowClear: true,
            },
            {
              type: 'remoteselect',
              name: 'project_id',
              label: '项目名称（单）',
              disabled: false,
              placeholder: '请选择服务项目',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-project',
            },
            {
              type: 'input',
              name: 'num',
              label: '项目次数',
              disabled: true,
            },
            {
              type: 'input',
              name: 'project_price',
              label: '项目金额',
              disabled: true,
              slots: { customRender: 'round_price' },
            },
            {
              type: 'number',
              name: 'diff_price',
              label: '换单价差',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '耗卡日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              showTime: true,
              placeholder: '请选择耗卡日期',
            },
            {
              type: 'textarea',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            project_id: [{ required: true, message: '请选项目名称' }],
            diff_price: [{ required: true, message: '请填写换单差价' }],
            customer_id: [{ required: true, message: '请选择会员姓名' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            card_num: [{ required: true, message: '请填写消耗卡次' }],
            date: [{ required: true, message: '请选择耗卡日期' }],
          },

          model: {
            org_id: current_org?.id,
            customer__name: record.customer__name,
            customer_id: record.customer_id,
            card__name: record.card__name,
            single_price: record.single_price,
            price: record.price,
            num: 1,
            shop_id: current_shop?.id,
            card_num: record.card_type == 11 && moment(record.end_date) < moment() ? 0 : 1,
          },
          watch: {
            project_id: (data: any) => {
              if (data['project_id'] > 0) {
                get_project_by_id({
                  org_id: current_org.id,
                  project_id: Number(data.project_id),
                }).then((res: any) => {
                  data['project_price'] = res.price;
                  data['diff_price'] = Number(data['project_price']) - Number(data['price']);
                });
              }
            },
            card_num: (data: any) => {
              data['price'] = Number(data['card_num']) * Number(data['single_price']);
              data['diff_price'] = Number(data['project_price']) - Number(data['price']);
            },
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            create_order_used_record_by_card({
              org_id: current_org?.id,
              card_record_id: record.id,
              project_id: payload.project_id,
              diff_price: payload.diff_price,
              customer_id: payload.customer_id,
              staff_id: payload.staff_id,
              shop_id: current_shop?.id,
              card_num: payload.card_num,
              num: payload.num,
              date: payload.date,
              mark: payload.mark,
            }).then(() => {
              notification.success({
                message: '成功',
                description: '耗卡成功',
              });
              resolve(null);
            });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '转卡',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.card_type == 31;
    },
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      let is_time_card = false;
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '转卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [5, 10],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'card__name',
              label: '原卡',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'number',
              name: 'card_use_num',
              label: '耗卡次数',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写耗卡次数',
            },
            {
              type: 'number',
              name: 'single_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目单价',
            },
            {
              type: 'number',
              name: '_old_card_sum_price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目金额',
            },
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'card_id',
              label: '新卡',
              disabled: false,
              placeholder: '请选择新卡',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-card',
            },
            {
              type: 'number',
              name: 'total_num',
              label: '项目次数',
              disabled: is_time_card,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'number',
              name: '_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'number',
              name: '_new_card_sum_price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'number',
              name: '_diff_price',
              label: '直接返利',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-querystaffselectlist',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '购卡日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              showTime: true,
              placeholder: '请选择购卡日期',
            },
            {
              type: 'textarea',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            card_id: [{ required: true, message: '请选新卡' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            card_use_num: [{ required: true, message: '请填写耗卡次数' }],
            total_num: [{ required: true, message: '请填写项目次数' }],
            date: [{ required: true, message: '请填写购卡时间' }],
            mark: [{ required: true, message: '请填写备注' }],
          },
          model: {
            org_id: current_org?.id,
            card_use_num: 1,
            total_num: 1,
            shop_id: current_shop?.id,
            single_price: data.single_price,
            card__name: data.card__name,
            customer__name: data.customer__name,
            customer_id: data.customer_id,
            card_record_id: data.id,
            _price: null, //显示使用
            _new_card_price: null, //计算使用
            _new_card_sum_price: null,
            _diff_price: null,
            _old_card_sum_price: data.single_price,
            staff_id: null,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            mark: null,
          },
          watch: {
            card_id: (newData: any) => {
              if (newData['card_id'] > 0) {
                get_card_by_id({
                  org_id: current_org.id,
                  card_id: Number(newData.card_id),
                }).then((res: any) => {
                  newData['_price'] = res.price.toFixed(0);
                  newData['_new_card_price'] = res.price;
                  newData['_new_card_sum_price'] = (
                    Number(newData['total_num']) * Number(newData['_new_card_price'])
                  ).toFixed(0);
                  if (res['card_type'] === 11) {
                    newData['total_num'] = res['max_num'];
                    is_time_card = true;
                  } else {
                    is_time_card = false;
                  }
                  const f = editModal.form.fields.find((item: any) => {
                    return item.name == 'total_num';
                  });
                  if (f) {
                    f.disabled = is_time_card;
                  }
                  newData['_diff_price'] = (
                    Number(newData['_new_card_sum_price']) - Number(newData['_old_card_sum_price'])
                  ).toFixed(0);
                });
              }
            },
            card_use_num: (newData: any) => {
              newData['_old_card_sum_price'] =
                Number(newData['card_use_num']) * Number(newData['single_price']);
              newData['_diff_price'] = (
                Number(newData['_new_card_sum_price']) - Number(newData['_old_card_sum_price'])
              ).toFixed(0);
            },
            total_num: (newData: any) => {
              newData['_new_card_sum_price'] = (
                Number(newData['total_num']) * Number(newData['_new_card_price'])
              ).toFixed(0);
              newData['_diff_price'] = (
                Number(newData['_new_card_sum_price']) - Number(newData['_old_card_sum_price'])
              ).toFixed(0);
            },
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            trans_card_record({
              ...payload,
              org_id: current_org?.id,
            })
              .then(function () {
                message.success('转卡成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', data.customer_id);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '撤卡',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.used_status == 2 || record.card_type == 1;
    },
    cb: (record: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      Modal.confirm({
        title: '撤卡仅用于客户退项目，若由于门店操作错误而需撤回订单，请点击作废。',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve1 => {
            const editModal = reactive({
              visible: true,
              loading: false,
              title: '撤卡',
              form: {
                settings: {
                  labelAlign: 'right',
                  layout: 'horizontal',
                  col: [4, 4],
                },
                fields: [
                  {
                    type: 'input',
                    name: 'customer__name',
                    label: '会员姓名',
                    disabled: true,
                  },
                  {
                    type: 'remoteselect',
                    name: 'card__name',
                    label: '卡',
                    disabled: true,
                    placeholder: '请选择卡',
                    datasourceType: 'remote',
                    mode: 'default',
                    allowClear: true,
                    modalType: 'mjstore-project',
                  },
                  {
                    type: 'input',
                    name: 'cancel_num',
                    label: '撤卡次数',
                    disabled: false,
                    allowClear: true,
                    inputType: 'number',
                    defaultValue: '',
                  },
                  {
                    type: 'textarea',
                    name: 'mark',
                    label: '备注',
                    disabled: false,
                    allowClear: true,
                    inputType: 'text',
                    maxlength: 300,
                    defaultValue: '',
                    placeholder: '请填写备注',
                  },
                  {
                    type: 'remoteselect',
                    name: 'shop_id',
                    label: '执行门店',
                    disabled: !!current_shop,
                    placeholder: '请选择执行门店',
                    datasourceType: 'remote',
                    mode: 'default',
                    allowClear: true,
                    modalType: 'mjstore-shop',
                  },
                  {
                    type: 'remoteselect',
                    name: 'staff_id',
                    label: '执行人',
                    disabled: false,
                    placeholder: '请选择执行人',
                    datasourceType: 'remote',
                    mode: 'default',
                    allowClear: true,
                    modalType: 'mjstore-staff',
                  },
                  {
                    type: 'datepicker',
                    name: 'date',
                    label: '撤卡时间',
                    disabled: false,
                    allowClear: true,
                    defaultValue: '',
                    showTime: true,
                    placeholder: '撤卡时间',
                  },
                  {
                    type: 'textarea',
                    name: 'reason',
                    label: '撤卡原因',
                    disabled: false,
                    allowClear: true,
                    inputType: 'text',
                    maxlength: 300,
                    defaultValue: '',
                    placeholder: '请填写撤卡原因',
                  },
                ],
                rules: {
                  staff_id: [{ required: true, message: '请选择执行人' }],
                  shop_id: [{ required: true, message: '请选择执行门店' }],
                  card_num: [{ required: true, message: '请填写消耗卡次' }],
                  num: [{ required: true, message: '请填写消耗单数' }],
                  cancel_num: [{ required: true, message: '请填写撤卡次数' }],
                  date: [{ required: true, message: '请选择撤卡时间' }],
                  mark: [{ required: true, message: '请填写备注' }],
                  reason: [{ required: true, message: '请填写撤卡原因' }],
                },

                model: {
                  org_id: current_org?.id,
                  customer__name: record.customer__name,
                  customer_id: record.customer_id,
                  card__name: record.card__name,
                  single_price: record.single_price,
                  price: record.price,
                  num: 1,
                  diff_price: 0,
                  card_num: record.now_num,
                  shop_id: current_shop?.id,
                },
                watch: {
                  project_id: (data: any) => {
                    if (data['project_id'] > 0) {
                      get_project_by_id({
                        org_id: current_org.id,
                        project_id: Number(data.project_id),
                      }).then((res: any) => {
                        data['project_price'] = res.price;
                        data['diff_price'] = Number(data['project_price']) - Number(data['price']);
                      });
                    }
                  },
                  card_num: (data: any) => {
                    data['price'] = Number(data['card_num']) * Number(data['single_price']);
                    data['diff_price'] = Number(data['project_price']) - Number(data['price']);
                  },
                },
              },
              options: {},
              ok: (payload: any) => {
                return new Promise(resolve => {
                  editModal.loading = true;
                  delete_card_record({
                    ...payload,
                    org_id: current_org?.id,
                    card_record_id: record.id,
                  })
                    .then(() => {
                      notification.success({
                        message: '成功',
                        description: '撤卡成功',
                      });
                      event_bus.emit('refresh_custom_info', record.customer_id);
                      resolve(null);
                      resolve1(null);
                    })
                    .finally(() => {
                      editModal.loading = false;
                    });
                });
              },
            });
            modalBox(editModal);
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
      });
    },
  },
  {
    name: '作废',
    //type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return !record.is_delete && record.now_num === record.total_num;
    },
    cb: (record: any) => {
      if (record.set_record_id) {
        Modal.confirm({
          title: '提示',
          content: `该项目所在套餐中的全部项目将同步作废，确定作废后请重新购买套餐`,
          onOk() {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            direct_delete_set_record({
              set_record_id: record.set_record_id,
              org_id: current_org?.id,
            }).then((res: any) => {
              if (res.show_message) {
                Modal.warning({
                  title: res.show_message,
                });
              } else {
                message.success('作废成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', record.customer_id);
              }
            });
          },
          onCancel() {},
        });
      } else {
        Modal.confirm({
          title: '提示',
          content: `是否作废此项记录`,
          onOk() {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            direct_delete_card_record({
              card_record_id: record.id,
              org_id: current_org?.id,
            }).then((res: any) => {
              if (res.show_message) {
                Modal.warning({
                  title: res.show_message,
                });
              } else {
                message.success('作废成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', record.customer_id);
              }
            });
          },
          onCancel() {},
        });
      }
    },
  },
  {
    name: '延期',
    //type: 'dropdown',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.card_type == 11 && record.used_status == 2;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const modifyModal: any = reactive({
        visible: false,
        component: 'ExtendCardRecordModel',
        obj: {
          org_id: current_org?.id,
          ...record,
        },
      });
      modifyModal.visible = true;
      modifyModal.ok = () => {
        event_obj.emit('refresh');
      };
      modifyModal.cancel = () => {};
      modalBox(modifyModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [
  {
    name: '新建',
    clazz: 'primary',
    icon: 'plus-outlined',
    cb: (data: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const formModel = reactive({
        org_id: current_org?.id,
        is_active: true,
        order_code: null,
        customer_id: data.customer_id,
        require_info_id: data.require_info_id,
        card_id: null,
        total_num: null,
        single_price: null,
        price: null,
        czje: 0,
        flje: 0,
        zjfl: 0,
        zjje: 0,
        date: null,
        cxzc_id: null,
        shop_id: current_shop?.id,
        staff_id: null,
        fl_rate: null,
        cz_rate: 1,
      });
      if (data.customer_id > 0) {
        get_customer_wallet_fl_rate({
          org_id: current_org.id,
          customer_id: Number(data.customer_id),
        }).then((res: any) => {
          formModel.fl_rate = res.fl_rate;
          formModel.cz_rate = 1 - res.fl_rate;
        });
      }
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '购卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [7, 7],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'remotemodal',
              name: 'customer_id',
              label: '会员姓名',
              disabled: true,
              placeholder: '请选择会员姓名',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-customer',
            },
            {
              type: 'remotemodal',
              name: 'card_id',
              label: '卡',
              disabled: false,
              placeholder: '请选择卡',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-card',
            },
            {
              type: 'number',
              name: 'total_num',
              label: '项目次数',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目次数',
            },
            {
              type: 'number',
              name: 'single_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目单价',
            },
            {
              type: 'number',
              name: 'price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写总价',
            },
            {
              type: 'number',
              name: 'czje',
              label: '充值使用金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写充值使用金额',
            },
            {
              type: 'number',
              name: 'flje',
              label: '返利使用金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写返利使用金额',
            },
            {
              type: 'number',
              name: 'zjfl',
              label: '直接返利',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写直接返利',
            },
            {
              type: 'number',
              name: 'zjje',
              label: '赠券使用金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写赠券使用金额',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '购卡日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              showTime: true,
              placeholder: '请选择购卡日期',
            },
            {
              type: 'remoteselect',
              name: 'cxzc_id',
              label: '促销政策',
              disabled: false,
              placeholder: '请选择促销政策',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-policy',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'input',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            customer_id: [{ required: true, message: '请填输入会员姓名' }],
            card_id: [{ required: true, message: '请填输入卡' }],
            date: [{ required: true, message: '请填输入购卡日期' }],
            shop_id: [{ required: true, message: '请填输入执行门店' }],
            staff_id: [{ required: true, message: '请选执行人' }],
            czje: [{ required: true, message: '请填写充值使用金额' }],
            flje: [{ required: true, message: '请填写返利使用金额' }],
            zjfl: [{ required: true, message: '请填写直接返利' }],
            zjje: [{ required: true, message: '请填写赠券使用金额' }],
            total_num: [{ required: true, message: '请填写项目次数' }],
            cxzc_id: [{ required: true, message: '请填写促销政策' }],
          },
          model: formModel,
          watch: {
            single_price: (data: any) => {
              data.price = data.single_price * data.total_num;
            },
            total_num: (data: any) => {
              data.price = data.single_price * data.total_num;
            },
            card_id: (data: any, form: any) => {
              if (data['card_id'] > 0) {
                get_card_by_id({
                  org_id: current_org.id,
                  card_id: Number(data.card_id),
                }).then((res: any) => {
                  if (res) {
                    // is_disable_total_num.value = true;
                    data.single_price = res.price;

                    const f = form.fields.find((item: any) => {
                      return item.name == 'total_num';
                    });
                    if (f) {
                      f.disabled = res.card_type == 11;
                      if (res.card_type == 11) {
                        data.total_num = res.max_num;
                      }
                    }
                  }
                });
              }
            },
            zjfl: (data: any) => {
              data['czje'] = (
                (data['price'] - data['zjfl'] - data['zjje']) *
                data['cz_rate']
              ).toFixed(0);
              data['flje'] = data['price'] - data['zjfl'] - data['zjje'] - data['czje'];
            },
            zjje: (data: any) => {
              data['czje'] = (
                (data['price'] - data['zjfl'] - data['zjje']) *
                data['cz_rate']
              ).toFixed(0);
              data['flje'] = data['price'] - data['zjfl'] - data['zjje'] - data['czje'];
            },
            customer_id: (data: any) => {
              get_customer_wallet_fl_rate({
                org_id: current_org.id,
                customer_id: Number(data.customer_id),
              }).then((res: any) => {
                data['fl_rate'] = res.fl_rate;
                data['cz_rate'] = 1 - res.fl_rate;
              });
            },
          },
        },
        options: {},
        ok: (modeldata: any) => {
          const p = new Promise(function (resolve) {
            if (
              Number(modeldata.czje) +
                Number(modeldata.flje) +
                Number(modeldata.zjfl) +
                Number(modeldata.zjje) !=
              Number(modeldata.price)
            ) {
              notification.error({
                message: '金额输入错误',
                description:
                  '下单金额应等于【充值使用金额】+【下单返利金额】+【直接返利金额】+【赠券使用金额】',
              });
              return false;
            }
            create_card_record({ ...modeldata, org_id: current_org?.id }).then((res: any) => {
              if (res.is_confirm) {
                Modal.confirm({
                  title: '提示',
                  content: res.message,
                  onOk() {
                    editModal.loading = true;
                    create_card_record({
                      ...modeldata,
                      org_id: current_org?.id,
                      is_confirm: true,
                    })
                      .then(function () {
                        message.success('创建成功');
                        event_obj.emit('refresh');
                        event_bus.emit('refresh_custom_info', data.customer_id);
                        resolve(null);
                      })
                      .finally(() => {
                        editModal.loading = false;
                      });
                  },
                  onCancel() {},
                });
              } else {
                message.success('创建成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', data.customer_id);
                resolve(null);
              }
            });
          });
          return p;
        },
      });
      modalBox(editModal);
    },
  },
];
